import w from "../assets/1-White.svg";
import u from "../assets/2-Blue.svg";
import b from "../assets/3-Black.svg";
import r from "../assets/4-Red.svg";
import g from "../assets/5-Green.svg";
import c from "../assets/6-Colourless.svg";

export const WUBRG = [
  {
    id: 1,
    title: "White",
    category: "w",
    colour: "white-mana",
    image: w,
  },
  {
    id: 2,
    title: "Blue",
    category: "u",
    colour: "blue-mana",
    image: u,
  },
  {
    id: 3,
    title: "Black",
    category: "b",
    colour: "black-mana",
    image: b,
  },
  {
    id: 4,
    title: "Red",
    category: "r",
    colour: "red-mana",
    image: r,
  },
  {
    id: 5,
    title: "Green",
    category: "g",
    colour: "green-mana",
    image: g,
  },
  {
    id: 6,
    title: "Colourless",
    category: "colorless",
    colour: "colourless-mana",
    image: c,
  },
];

export const setList = [
  { id: 1, abbr: "woe", name: "Wilds of Eldraine" },
  { id: 2, abbr: "mid", name: "Innistrad: Midnight Hunt" },
  { id: 3, abbr: "neo", name: "Kamigawa: Neon Dynasty" },
  { id: 4, abbr: "dmu", name: "Dominaria United" },
  { id: 5, abbr: "bro", name: "The Brothers' War" },
  { id: 6, abbr: "one", name: "Phyrexia: All Will Be One" },
  { id: 7, abbr: "mom", name: "March of the Machine" },
  { id: 8, abbr: "lci", name: "The Lost Caverns of Ixalan" },
  { id: 9, abbr: "vow", name: "Innistrad: Crimson Vow" },
  { id: 10, abbr: "sld", name: "Secret Lair Drop" },
];

export const compareCards = [];

export const fblthpData = [
  {
    id: 1,
    link: "https://cards.scryfall.io/art_crop/front/c/3/c36f01a5-82bf-4fc6-9396-4410067c351b.jpg?1702429424",
  },
  {
    id: 2,
    link: "https://cards.scryfall.io/art_crop/front/7/9/79b2c547-0d9e-4fd7-a399-347ad908c70b.jpg?1702429390",
  },
  {
    id: 3,
    link: "https://cards.scryfall.io/art_crop/front/0/1/01d3e6ea-4791-4948-af22-c1bd04c34c1e.jpg?1708702980",
  },
  {
    id: 4,
    link: "https://cards.scryfall.io/art_crop/front/4/5/450c264f-008b-4360-b0ee-f0448ca8fedc.jpg?1673913700",
  },
];

// {name:
// manacost:
// type:
// usd:
// eur:
// power:
// toughness:
// rarity:}
